import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/ui-bits";
import { GoogleButton } from "@/pages/Inloggen";
import { useLang } from "@/lib/i18n";

export const Registreren = () => {
  const navigate = useNavigate();
  const { register } = useAuth();
  const { t } = useLang();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await register(form.name, form.email, form.password);
      navigate("/account", { replace: true });
    } catch (err) {
      setError(formatApiError(err));
      setBusy(false);
    }
  };

  const field = (key, label, testid, type = "text", extra = {}) => (
    <label className="block">
      <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-smoke block mb-2">{label}</span>
      <input
        data-testid={testid}
        type={type}
        required
        value={form[key]}
        onChange={(e) => setForm({ ...form, [key]: e.target.value })}
        className="w-full bg-obsidian border border-gold/15 px-4 py-3.5 text-sm text-cream focus:outline-none focus:border-gold/50"
        {...extra}
      />
    </label>
  );

  return (
    <div className="min-h-screen flex items-center justify-center px-6 pt-28 pb-16">
      <div className="w-full max-w-md">
        <PageHeader eyebrow={t("auth.regEyebrow")} title={<>{t("nav.register").split(" ")[0]} <span className="italic normal-case text-gold">{t("nav.register").split(" ").slice(1).join(" ")}</span></>} />
        <form data-testid="register-form" onSubmit={submit} className="border border-gold/15 bg-ink p-8 space-y-5">
          {field("name", t("auth.name"), "register-name-input", "text", { minLength: 2 })}
          {field("email", t("auth.email"), "register-email-input", "email")}
          {field("password", t("auth.regPw"), "register-password-input", "password", { minLength: 8 })}
          {error && <p data-testid="register-error" className="text-xs text-red-400">{error}</p>}
          <button type="submit" data-testid="register-submit-button" disabled={busy} className="w-full bg-gold text-obsidian font-mono text-[11px] tracking-[0.3em] uppercase py-4 hover:bg-gold-light transition-colors disabled:opacity-40">
            {busy ? t("auth.busy") : t("auth.regBtn")}
          </button>
          <div className="flex items-center gap-3">
            <span className="h-px flex-1 bg-gold/10" /><span className="font-mono text-[9px] text-smoke uppercase tracking-[0.2em]">{t("auth.or")}</span><span className="h-px flex-1 bg-gold/10" />
          </div>
          <GoogleButton label={t("auth.regGoogle")} />
          <p className="text-center pt-2">
            <Link data-testid="to-login" to="/inloggen" className="font-mono text-[10px] tracking-[0.15em] uppercase text-mist hover:text-gold transition-colors">{t("auth.hasAccount")}</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default Registreren;
